import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import Table from './Table';
import CardHeader from './CardHeader';
import { loadOperationsAction } from '../actions';

class Card extends Component {

  componentWillMount() {
    const { dispatch } = this.props;

    const filters = [
      {filter: "first", value: 50},
      {filter: "skip", value:  0}
    ]

    dispatch(loadOperationsAction(filters));
  }

  render() {
    return (
      <div className="card shadow">
        <CardHeader />
        <Fragment>
          <Table operations={this.props.operations} />
        </Fragment>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { zwallet } = state;
  return { operations: zwallet.extract.operations }
}

export default connect(mapStateToProps)(Card);


// WEBPACK FOOTER //
// ./src/ZWallet/Operations/components/Card.js